import { inject, Injectable } from '@angular/core'
import { TuiAlertService, TuiAppearanceOptions } from '@taiga-ui/core'
import { TranslateService } from '@ngx-translate/core'

@Injectable({
	providedIn: 'root',
})
export class AlertService {
	protected readonly autoCloseMs: number = 5000

	private readonly _tuiAlertService: TuiAlertService = inject<TuiAlertService>(TuiAlertService)
	private readonly _translateService: TranslateService = inject<TranslateService>(TranslateService)

	private _getLabelPath(appearanceOptions: TuiAppearanceOptions): string {
		switch (appearanceOptions.appearance) {
			case 'positive':
				return 'notification.success'
			case 'negative':
				return 'notification.error'
			case 'warning':
				return 'notification.warning'
			default:
				return ''
		}
	}

	private _show(message: string, { appearance }: TuiAppearanceOptions, autoCloseMs: number = this.autoCloseMs): void {
		this._tuiAlertService
			.open(message, {
				appearance,
				autoClose: autoCloseMs,
				label: this._translateService.instant(this._getLabelPath({ appearance })),
			})
			.subscribe()
	}

	public success(message: string, autoCloseMs: number = this.autoCloseMs): void {
		this._show(message, { appearance: 'positive' }, autoCloseMs)
	}

	public error(message: string, autoCloseMs: number = this.autoCloseMs): void {
		this._show(message, { appearance: 'negative' }, autoCloseMs)
	}

	public warning(message: string, autoCloseMs: number = this.autoCloseMs): void {
		this._show(message, { appearance: 'warning' }, autoCloseMs)
	}
}
